import store from "../rootReducer";
import {
  ADDRESS,
  CLEAR_ORDER_STATE,
  CLEAR_RECEIVER_MENU,
  CLEAR_STATE,
  CLIENT,
  COMPANY,
  CURRENT_STEP,
  FACILITY,
  INFORMATION,
  ORDER,
  ORDER_MOVE_ENABLED,
  RECEIVER_MENU,
  SET_IS_ORDER_FITTING_ENABLED,
  SET_IS_ORDER_FUNCTION_ENABLED,
  SET_IS_ORDER_NEW_PRODUCT_ENABLED,
  SET_IS_ORDER_PICKUP_ENABLED,
  SET_IS_ORDER_WORK_ENABLED,
  SET_IS_RECEIVE_DELIVERY_FOR_FIXED_ASSETS_ENABLED,
  USERNAME,
} from "./appDataVariables";

export function setClient(client) {
  store.dispatch({ type: CLIENT, client });
}

export function setOrder(order) {
  store.dispatch({ type: ORDER, order });
}

export function clearOrder() {
  store.dispatch({ type: CLEAR_ORDER_STATE });
}

export function setIsOrderFittingEnabled(isOrderFittingEnabled) {
  store.dispatch({ type: SET_IS_ORDER_FITTING_ENABLED, isOrderFittingEnabled });
}

export function setIsOrderFunctionEnabled(isOrderFunctionEnabled) {
  store.dispatch({ type: SET_IS_ORDER_FUNCTION_ENABLED, isOrderFunctionEnabled });
}

export function setIsOrderNewProductEnabled(isOrderNewProductEnabled) {
  store.dispatch({ type: SET_IS_ORDER_NEW_PRODUCT_ENABLED, isOrderNewProductEnabled });
}

export function setIsOrderPickupEnabled(isOrderPickupEnabled) {
  store.dispatch({ type: SET_IS_ORDER_PICKUP_ENABLED, isOrderPickupEnabled });
}

export function setIsOrderWorkEnabled(isOrderWorkEnabled) {
  store.dispatch({ type: SET_IS_ORDER_WORK_ENABLED, isOrderWorkEnabled });
}

export function setOrderMoveEnabled(orderMoveEnabled) {
  store.dispatch({ type: ORDER_MOVE_ENABLED, orderMoveEnabled });
}

export function setIsReceiveDeliveryForFixedAssetsEnabled(isReceiveDeliveryForFixedAssetsEnabled) {
  store.dispatch({ type: SET_IS_RECEIVE_DELIVERY_FOR_FIXED_ASSETS_ENABLED, isReceiveDeliveryForFixedAssetsEnabled });
}

export function setUserName(username) {
  store.dispatch({ type: USERNAME, username });
}

export function setAddress(address) {
  store.dispatch({ type: ADDRESS, address });
}

export function setCompany(company) {
  store.dispatch({ type: COMPANY, company });
}

export function setFacility(facility) {
  store.dispatch({ type: FACILITY, facility });
}

export function setInformation(information) {
  store.dispatch({ type: INFORMATION, information });
}

export function setReceiverMenu(receiverMenu) {
  store.dispatch({ type: RECEIVER_MENU, receiverMenu });
}
// Only re-initialize this reducer
export function clearAppData() {
  store.dispatch({ type: CLEAR_STATE });
}

export function clearReceiverMenu() {
  store.dispatch({ type: CLEAR_RECEIVER_MENU });
}

export function setCurrentStep(currentStep) {
  store.dispatch({ type: CURRENT_STEP, currentStep });
}
